<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7VqGWK/images/MyLuckyStar-cover.jpg?1733067604828" alt="This image is the cover for the book My Lucky Star"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Lucky Star
      </h1>
      <p class="bookDescription body article font2">
        <b>In this hilarious, laser-sharp comedy, the Emmy-winning writer and producer of <i>Frasier</i> sends up Hollywood pretense higher than it's ever been sent before.<b></b></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Keenan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Back Bay Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?829780c8